/* Publish by EComposer at 2025-07-30 11:26:37*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lefck2c1d3e"]=  window.__ectimmers["ecom-lefck2c1d3e"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-lefck2c1d3e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lefck2c1d3e', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nb4qqlmwitj"]=  window.__ectimmers["ecom-nb4qqlmwitj"] || {};
var t;if(!this.$el)return;const e=this.$el;if(this.settings.style==="slider"){let i=e.querySelector(".ecom-swiper-container"),s=i&&i.dataset.optionSwiper;if(!s)return;let l="bullets";this.settings.slider_pagination_style==="progress"&&(l="progressbar"),s=JSON.parse(s),s.pagination={el:e.querySelector(".ecom-swiper-pagination"),type:l,clickable:!0},s.navigation={nextEl:e.querySelector(".ecom-swiper-button-next"),prevEl:e.querySelector(".ecom-swiper-button-prev")},s.autoHeight=!1,s.spaceBetween=(t=this.settings.slider_spacing)!=null?t:25,window.EComSwiper&&new window.EComSwiper(i,s)}

                    });
                    
                        document.querySelectorAll('.ecom-nb4qqlmwitj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nb4qqlmwitj', settings: {"style":"grid"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}